import { defineMessages } from 'react-intl';

export const texts = defineMessages({
  upsertChatGroupError: {
    id: 'useUpsertChatGroup.upsertChatGroupError',
    description: 'Upsert chat group error',
    defaultMessage: 'Kunde inte skapa gruppen',
  },
});
